import React from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Button from 'epn-ui/umd/dist/components/Button';
import useI18n from '@i18n';
import BaseSemanticLink from '@base/BaseSemanticLink';
import routes from '@config/routes.json';
import BaseSanitizer from '@base/BaseSanitizer';

interface IBanReasonModal {
    isOpen: boolean;
    reason: string;
    onClose: () => void;
}

const BanReasonModal: React.FC<IBanReasonModal> = ({ isOpen, reason, onClose }) => {
    const { t } = useI18n('Offers');

    return (
        <Dialog onCancel={onClose} open={isOpen} size="sm">
            <div className="p-[8px] xs-[16px]">
                <p className="font-bold text-center text-blueGray-800 text-[24px] leading-[35px]">
                    {t('Connection rejected')}
                </p>

                <BaseSanitizer
                    html={reason}
                    tag="p"
                    options={{ allowedTags: ['a'] }}
                    className="w-full text-center my-[24px] text-blueGray-600"
                />
                <BaseSemanticLink to={routes.support.open} target="_blank">
                    <Button type="primary" className="w-full">
                        {t('Contact support about ban')}
                    </Button>
                </BaseSemanticLink>
            </div>
        </Dialog>
    );
};

export default BanReasonModal;
